/* eslint-disable */
import { CR, RC, AJRS } from './base_i2_success_codes'
import bi1_data_validation from './base_i1_datavalidation'
import base_i3_log from './base_i3_logging'
import checkIfWatchdogUserExists from './legacy_calls/p2s1t1_CheckIfUserExists'
import p2s1t3_CreateNewUser from './legacy_calls/p2s1t3_CreateNewUser'
import 'vue'
import localForage from 'localforage';

const local_forage = localForage;

local_forage.config({
  driver: [
    local_forage.INDEXEDDB,
    local_forage.LOCALSTORAGE,
    local_forage.WEBSQL
  ],
  name: 'DGnet_Web_GUI'
});

class bi8_vue_data_connectors {

  //when we do website updates we want don't old cached data causing issues
  static async bi8LocalStorageVersionCheck(version) {
    var current_storage_version = localStorage.getItem('watchdog_cache_version');
    if (current_storage_version !== version || current_storage_version === null) {
      localStorage.clear()
      localStorage.setItem('watchdog_cache_version', version)
      console.log('clearing local Storage');
    }

    var current_forage_version = await local_forage.getItem('watchdog_cache_version');
    if (current_forage_version !== version || current_forage_version === null) {
      local_forage.clear()
      local_forage.setItem('watchdog_cache_version', version)
      console.log('clearing local Forage');
    }
  }
  static bi8SetVueUserInfoSuccess() {
    window.G_vue_instance.$root.$data.userInfo.firstName = window.G_web_gui_data.IV_user_info['first_name']
    window.G_vue_instance.$root.$data.userInfo.lastName = window.G_web_gui_data.IV_user_info['last_name']
    window.G_vue_instance.$root.$data.userInfo.contactEmail =  window.G_web_gui_data.IV_user_info['contact_email']
    
    /// We are not getting guest user info from firestore. 
    if (window.G_web_gui_data.IV_user_info['uid'] === 0 && window.G_vue_instance.$root.$data.userInfo.isGuest === true) {
      window.G_vue_instance.$root.$data.webGui.watchdogDbConnected = true;
    }
    /// </end> We are not getting guest user info from firestore. 

    if (window.G_vue_instance.$root.$data.userInfo.uid !== window.G_web_gui_data.IV_user_info['uid']) {
      window.G_vue_instance.$root.$data.userInfo.uid = window.G_web_gui_data.IV_user_info['uid']

      window.G_vue_instance.$root.$data.webGui.watchdogDbConnected = true;
    }
  }

  static bi8SignInCallback() {
    if (window.G_firebase_auth.IV_token_received === false || typeof G_firebase_auth.IV_uid !== 'string' ||  G_firebase_auth.IV_uid.length < 5) {
      setTimeout(bi8_vue_data_connectors.bi8SignInCallback,300);
    }
    window.G_vue_instance.$root.$data.userInfo.isGuest = window.G_firebase_auth.IV_is_guest;
    window.G_vue_instance.$root.$data.userInfo.authenticated = window.G_firebase_auth.IV_token_received;

    window.G_web_gui_data.setFirebaseParams(
      window.firebase.database(),
      window.G_firebase_auth.bi5TokenProperty,
      window.G_firebase_auth.bi5FirebaseUidProperty,
      window.G_firebase_auth.bi5FirebaseEmailAddressProperty,
      window.G_firebase_auth.bi5FirebaseGuestFlagProperty
    );

    //refresh user info
    if(!G_firebase_auth.IV_is_guest) {
      checkIfWatchdogUserExists(window.G_firebase_auth.IV_email_address).then(
        function(){},
        function() {
          p2s1t3_CreateNewUser(
            G_firebase_auth.IV_email_address, 
            G_firebase_auth.IV_first_name,
            G_firebase_auth.IV_last_name,
            G_firebase_auth.IV_uid
          ); 
        }
      );
    }
    window.G_web_gui_data.InitUserInfoListener();
  }

  static bi8SignOutCallback() {
    window.G_vue_instance.$root.$data.webGui.watchdogDbConnected = false;
    localStorage.clear();
    localStorage.removeItem('vuex');
    location.assign(window.location.origin + '/');
  }

  static bi8FirebaseTokenUpdatedCallback() {
    window.G_web_gui_data.bi7SetFirebaseToken(G_firebase_auth.bi5TokenProperty);
  }
}

export default bi8_vue_data_connectors
//once the file is loaded put it in the list of loaded includes
if (typeof window.loaded_includes === "undefined") { window.loaded_includes = {} }
window.loaded_includes['base_i8'] = true;



// WEBPACK FOOTER //
// ./src/watchdog_includes/base_i8_vue_data_connectors.js